import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const GenderIdentityChoices = [
  { label: l`global.man`, id: "MAN" },
  { label: l`global.woman`, id: "WOMAN" },
  { label: l`global.transgenderMan`, id: "TRANSGENDER_MAN" },
  { label: l`global.transgenderWoman`, id: "TRANSGENDER_WOMAN" },
  { label: l`global.nonBinary`, id: "NON_BINARY" },
  { label: l`global.somethingElse`, id: "SOMETHING_ELSE" }
]

export default GenderIdentityChoices
